module.exports = __webpack_public_path__ + "img/logo.eb8b33b4.png";